import { Component, Inject, OnDestroy  } from '@angular/core';
import { JOYRIDE_DIALOG_DATA, JOYRIDE_DIALOG_FUNCTIONS } from './joyride.tokens';
import { BehaviorSubject } from 'rxjs';

@Component({
    template: `
        <div class="joyride-card mat-elevation-z3">
            <h3 class="title">{{message.title}}</h3>
            <div class="content" [innerHTML]="message.text"></div>
            <div class="actions">
                <span *ngIf="message.loading">{{message.loadingText}}</span>
                <button [disabled]="message.loading || paused" class="button small" *ngIf="message.hasNext" (click)="fn.next()">Next</button>
                <button class="button small" (click)="fn.done()">End</button>
            </div>
        </div>
    `,
})
export class JoyrideOverlayComponent implements OnDestroy {
    message:any = {
        title: '',
        text: '',
        hasNext: false,
        loadingText: 'loading...',
        loading: false
    };
    paused = false;
    dataSubscription;
    loadingSubscription;
    pausedSubscription;
    constructor(@Inject(JOYRIDE_DIALOG_DATA) public data: BehaviorSubject<any>, @Inject(JOYRIDE_DIALOG_FUNCTIONS) public fn: any) {
        this.dataSubscription = this.data.subscribe(data => {
            if( data ) {
                this.setMessage(data);
                setTimeout(() => {
                    this.fn.reposition(data);
                }, 50);                
            }
        });
        this.pausedSubscription = this.fn.paused.subscribe(isPaused => {
            this.paused = isPaused;
        });
    }
    setMessage(data) {
        this.reset();
        Object.assign(this.message, data);
        if( data.loadingNext ) {
            this.loadingSubscription = data.loadingNext.asObservable().subscribe(isLoading => {
                this.message.loading = isLoading;
            });
        }
    }
    reset() {
        this.message = {
            title: '',
            text: '',
            hasNext: false,
            loadingText: 'loading...',
            loading: false
        };
        if( this.loadingSubscription ) {
            this.loadingSubscription.unsubscribe();
        }
    }
    ngOnDestroy() {
        this.reset();
        if( this.dataSubscription ) {
            this.dataSubscription.unsubscribe();
        }
        if( this.pausedSubscription ) {
            this.pausedSubscription.unsubscribe();
        }
    }
}